import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=f6a30f9e&scoped=true&"
import script from "./Share.vue?vue&type=script&lang=js&"
export * from "./Share.vue?vue&type=script&lang=js&"
import style0 from "./Share.scss?vue&type=style&index=0&id=f6a30f9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a30f9e",
  null
  
)

export default component.exports